var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternalDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28.8 37.5h-15c-3.1 0-5.7-2.5-5.7-5.7V10.7c0-3.1 2.5-5.7 5.7-5.7H29c3.1 0 5.7 2.5 5.7 5.7v21.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M14 19.4h14.4M19.6 12.7h8.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 14,
    cy: 12.7,
    r: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M14 24.7h5M23.4 24.7h5M14 29.9h5M23.4 29.9h5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalDocuments);
export default __webpack_public_path__ + "static/media/internalDocuments.90eb16e831559f92186e75ba99c2c929.svg";
export { ForwardRef as ReactComponent };